<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-09-01 09:39:27
-->
<template>
	<div class="yx-form-wrap">
		<el-form :inline="true" :model="formData" label-width="96px">
			<el-form-item :label="item.label" v-for="(item, index) in screenList" :key="index">
				<template v-if="item.module == 'date'">
					<el-date-picker
						v-model="freeOrderTime"
						type="daterange"
						@change="value => changeTimed(value, item)"
						value-format="yyyy-MM-dd"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
					>
					</el-date-picker>
				</template>
				<el-input
					v-model="formData[item.searchKey || item.key]"
					:placeholder="'请输入' + item.label"
					v-if="item.module == 'input'"
					@keyup.13.native="onSubmit"
				></el-input>
				<el-select v-if="item.module == 'select'" v-model="formData[item.searchKey || item.key.replace('_text', '')]" clearable placeholder="请选择">
					<el-option :label="unit.label" :value="unit.value" v-for="(unit, ind) in item.selectList" :key="ind + unit"></el-option>
				</el-select>
				<template class="scope-input" v-if="item.module == 'section'">
					<el-input v-model="formData[item.key + '_start']" placeholder="最小值"></el-input>
					<span class="flag">至</span>
					<el-input v-model="formData[item.key + '_end']" placeholder="最大值"></el-input>
				</template>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit">筛选</el-button>
				<el-button @click="onClear">清空</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
export default {
	name: 'searchForms',
	components: {},
	props: {
		screenList: {
			type: Array,
			default: () => {
				return [];
			},
		},
	},
	data() {
		return {
			formData: {},
			freeOrderTime: '',
		};
	},
	methods: {
		onClear() {
			this.formData = {};
			this.freeOrderTime = '';
			this.onSubmit();
		},
		changeTimed(value, item) {
			const [start, end] = value || [];
			const [startTimeKey, endTimeKey] = item.searchKey || [];
			this.formData[startTimeKey] = start ? Date.parse(start) / 1000 - 8 * 3600 : '';
			this.formData[endTimeKey] = end ? Date.parse(end) / 1000 + 16 * 3600 - 1 : '';
		},
		onSubmit: throttle(function () {
			this.$emit('onSubmit', this.formData);
		}, 1000),
	},
};
</script>

<style lang="less" scoped></style>
